import * as React from "react";
import { useEffect, useState, useCallback, useContext } from "react";
import styled, { css } from "styled-components";
import { MenuItem } from "components/bootstrap";
import DashboardPageContext from "views/components/contexts/DashboardPageContext";
import useViewsDispatch from "views/stores/useViewsDispatch";
import { duplicateQuery } from "views/logic/slices/viewSlice";
import QueryActionDropdown from "./QueryActionDropdown";
const Container = styled.div`
  display: flex;
  align-items: center;
`;
const TitleWrap = styled.span(
  ({ $active }) => css`
    padding-right: ${$active ? "6px" : "0"};
  `
);
const QueryTitle = ({
  active,
  allowsClosing = true,
  id,
  onRemove,
  openEditModal,
  openCopyToDashboardModal,
  title
}) => {
  const [titleValue, setTitleValue] = useState(title);
  const { setDashboardPage } = useContext(DashboardPageContext);
  const dispatch = useViewsDispatch();
  useEffect(() => {
    setTitleValue(title);
  }, [title]);
  const _onDuplicate = useCallback(
    () => dispatch(duplicateQuery(id)).then((queryId) => setDashboardPage(queryId)),
    [dispatch, id, setDashboardPage]
  );
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(TitleWrap, { "aria-label": titleValue, $active: active, "data-testid": "query-tab", "data-active-query-tab": active }, titleValue), active && /* @__PURE__ */ React.createElement(QueryActionDropdown, null, /* @__PURE__ */ React.createElement(MenuItem, { onSelect: () => openEditModal(titleValue) }, "Edit Title"), /* @__PURE__ */ React.createElement(MenuItem, { onSelect: _onDuplicate }, "Duplicate"), /* @__PURE__ */ React.createElement(MenuItem, { onSelect: () => openCopyToDashboardModal(true) }, "Copy to Dashboard"), /* @__PURE__ */ React.createElement(MenuItem, { divider: true }), /* @__PURE__ */ React.createElement(MenuItem, { onSelect: onRemove, disabled: !allowsClosing }, "Delete")));
};
export default QueryTitle;
